<template>
  <section class="section items-center justify-around h-auto vertical">
    <div class="flex flex-col md:flex-row">
      <Overdraft-chart
        class="progress-circle md:relative md:inline-block"
        v-bind:amount="'₲ ' + avail_balance | currency"
        v-bind:percent="percent_of_overdraft_of_total"
        v-bind:text_top="'TIENES'"
        v-bind:text_bottom="'DISPONIBLE'"
        v-bind:primary_color="'url(#gradientPrimary)'"
        v-bind:secondary_color="'url(#gradientSecondary)'"
        v-bind:cap="'none'"
      />
      <Overdraft-chart
        class="progress-circle md:relative md:inline-block"
        v-bind:amount="percent_used_overdraft + '%'"
        v-bind:percent="percent_used_overdraft"
        v-bind:text_top="'USAS'"
        v-bind:text_bottom="'SOBREGIRO'"
        v-bind:primary_color="'url(#gradientSecondary)'"
        v-bind:secondary_color="'rgba(255, 255, 255, 0.4)'"
        v-bind:cap="'round'"
      />
    </div>
    <div class="key-wrapper">
      <Key
        v-bind:percent="percent_overdraft"
        v-bind:color="'#e53935'"
        v-bind:name="'SOBREGIRO'"
        v-bind:value="overdraft"
      />
      <Key
        v-bind:percent="percent_additional_overdraft"
        v-bind:color="'#f44336'"
        v-bind:name="'ADICIONAL'"
        v-bind:value="additional_overdraft"
      />
      <Key
        v-bind:percent="percent_authorized_overdraft"
        v-bind:color="'#ef5350'"
        v-bind:name="'AUTORIZADO'"
        v-bind:value="authorized_overdraft_Checked"
      />
    </div>
  </section>
</template>

<script>
import OverdraftChart from "@/components/overdraft/Circle.vue";
//import Pie from "@/components/overdraft/Pie.vue";
import Key from "@/components/overdraft/Key.vue";

export default {
  name: "Overdraft",
  components: {
    OverdraftChart,
    //Pie,
    Key
  },
  props: {
    balance: {
      type: Number,
      default: 0
    },
    overdraft: {
      type: Number,
      default: 0
    },
    additional_overdraft: {
      type: Number,
      default: 0
    },
    authorized_overdraft: {
      type: Number,
      default: 0
    },
    authorized_overdraft_expiry: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      /*balance: -2500000,
      overdraft: 9768313,
      additional_overdraft: 2000,
      authorized_overdraft: 200000*/
    };
  },
  computed: {
    sum_overdraft() {
      const sum =
        this.overdraft +
        this.additional_overdraft +
        this.authorized_overdraft_Checked;
      return sum;
    },
    percent_overdraft() {
      if (this.sum_overdraft == 0) return 0;
      return (this.overdraft / this.sum_overdraft) * 100;
    },
    percent_additional_overdraft() {
      if (this.sum_overdraft == 0) return 0;
      return (this.additional_overdraft / this.sum_overdraft) * 100;
    },
    authorized_overdraft_Checked() {
      if (Date.parse(this.authorized_overdraft_expiry) < Date.now()) return 0;
      else return this.authorized_overdraft;
    },
    percent_authorized_overdraft() {
      if (this.sum_overdraft == 0) return 0;
      return (this.authorized_overdraft_Checked / this.sum_overdraft) * 100;
    },
    percent_used_overdraft() {
      if (this.sum_overdraft == 0) return 100;
      if (this.balance < 0)
        return ((Math.abs(this.balance) / this.sum_overdraft) * 100).toFixed(2);
      else return 0;
    },
    avail_balance() {
      return this.balance + this.sum_overdraft > 0
        ? this.balance + this.sum_overdraft
        : 0;
    },
    percent_of_overdraft_of_total() {
      if (this.balance <= 0) return 0;
      if (this.sum_overdraft == 0) return 100;
      return 100 - (this.sum_overdraft / this.avail_balance) * 100;
    }
  }
};
</script>

<style scoped>
</style>
